import { createSlice, current } from "@reduxjs/toolkit";


const initialState = {
    data: {
        reportsdata: [],
        tspReports: [],
        facilitiesdata:[],
    },
    loading: false,
    error: null,
};

const reportsSlice = createSlice({
    name: 'reports',
    initialState,
    reducers: {

        // Loading .... 

        start(state) {
            state.loading = true;
            state.error = null;
        },
        failure(state, action) {
            state.loading = false;
            state.error = action.payload;
        },

        // facilities store ...... 

        getSavedReportsSuccess(state, action) {
            state.loading = false;
            state.data.reportsdata = action.payload;
        },

        deleteReportsData(state, action) {
            state.loading = false;
            const idToDelete = action.payload;
            state.data.reportsdata = state.data.reportsdata.filter(
                (report) => report.id !== idToDelete
            );
        },
         deleteFacilities(state, action) {
            state.loading = false;
            const idToDelete = action.payload;
            state.data.reportsdata = state.data.reportsdata.filter(
                 facility => facility.id !== action.payload
            );
        },

        resetReportsState: (state) => {
            state.loading = false;
            state.data.reportsdata = [];
        },

        deleteTspReport: (state, action) => {
            state.tspReports = state.tspReports.filter(report => report.id !== action.payload);
        },




    },
});

export default reportsSlice.reducer;
export const {
    start,
    failure,
    getSavedReportsSuccess,
    deleteReportsData,
    resetReportsState,
    deleteTspReport,
    deleteFacilities
} = reportsSlice.actions;